import React, { useMemo, useState } from 'react';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import clsx from 'clsx';

import AppAddPillButton from '../../../../components/designe/buttons/app-add-pill-button/AppAddPillButton';
import NoResults from '../../../../components/reusable/no-results';
import Search from '../../../../components/reusable/search/Search';
import WithListObservers from '../../../../hoc/with-list-observers';
import { IProgramCollection } from '../../../../types/interfaces/program-collection';
import { useStyles } from './ProgramCollectionList.styles';
import ProgramCollectionItemSkeleton from './program-collection-item-skeleton/ProgramCollectionItemSkeleton';
import ProgramCollectionListItem from './program-collection-list-item/ProgramCollectionListItem';

const SKELETON_COUNT = 4;

interface IProgramListProps {
  programCollections: IProgramCollection[] | null;
  onItemClick: (p: IProgramCollection) => void;
  onAddClick?: () => void;
  isLoading?: boolean;
}

const ProgramCollectionList = (props: IProgramListProps) => {
  const {
    programCollections,
    onItemClick,
    onAddClick,
    isLoading = false,
  } = props;
  const [filter, setFilter] = useState('');
  const filteredProgramCollections = useMemo(
    () =>
      programCollections?.filter(
        (program) =>
          program.title.toLowerCase().indexOf(filter?.toLowerCase()) !== -1,
      ),
    [filter, programCollections],
  );
  const theme = useTheme();

  const { classes } = useStyles(theme);

  const showNoResult =
    !isLoading &&
    !!filteredProgramCollections &&
    !filteredProgramCollections?.length;

  return (
    <div className={classes.programCollectionListWrapper}>
      <Box className={classes.programCollectionListHeader}>
        <Search
          fullWidth
          value={filter}
          onChange={setFilter}
          className={classes.programCollectionListSearch}
        />
        {onAddClick && <AppAddPillButton onClick={() => onAddClick()} />}
      </Box>

      {showNoResult && <NoResults />}

      {isLoading && (
        <WithListObservers
          wrapperClassName={clsx(
            classes.programCollectionListContainer,
            onAddClick && classes.programCollectionListContainerWithAddButton,
          )}>
          <Box display="flex" flexDirection="column">
            {Array.from({ length: SKELETON_COUNT }, (_, i) => (
              <ProgramCollectionItemSkeleton key={i} />
            ))}
          </Box>
        </WithListObservers>
      )}

      {!isLoading &&
        filteredProgramCollections &&
        filteredProgramCollections.length > 0 && (
          <WithListObservers
            wrapperClassName={clsx(
              classes.programCollectionListContainer,
              onAddClick && classes.programCollectionListContainerWithAddButton,
            )}>
            {filteredProgramCollections.map((programCollection) => (
              <ProgramCollectionListItem
                key={programCollection.id}
                programCollection={programCollection}
                onItemClick={onItemClick}
              />
            ))}
          </WithListObservers>
        )}
    </div>
  );
};

export default ProgramCollectionList;
